export const REPORT_CELL_REFRESH =
  Number(import.meta.env.REACT_APP_REPORT_CELL_POLLING_INTERVAL) || 3000;

export const REPORT_VISIBLE_CELL_REFRESH =
  Number(import.meta.env.REACT_APP_REPORT_CELL_POLLING_INTERVAL) || 30000;
